<template>
  <div id="areamaps">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-tooltip class="item" effect="dark" :content="$t('contentManagement.areaMap.searchFilter')" placement="top">
              <el-button icon="fas fa-search" :type="$store.state.livesessions.filter.searchTerm != '' && $store.state.livesessions.filter.searchTerm != null ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateFormId = null;
                modalVisible = true;
              "
              >{{ $t("contentManagement.areaMap.addMap") }}</el-button
            >
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("contentManagement.areaMap.filter") }}</h5>
                <span>{{ $t("contentManagement.areaMap.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="$store.state.areamaps.filter.searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.areamaps.filter.searchTerm" :placeholder="$t('event.textbox.filterLabel')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.areamap.title") }}</h5>
              <span v-if="$store.state.areamaps.items.length > 0" v-html="$t('totalContent', [$store.state.areamaps.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="$store.state.areamaps.items.length > 0">
            <div class="custom-grid-table-header area-maps-grid-template">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <div>{{ $t("contentManagement.areaMap.map") }}</div>
              <div>{{ $t("contentManagement.areaMap.view") }}</div>
              <div></div>
            </div>
            <draggable :list="$store.state.areamaps.items" tag="div" handle=".el-icon-s-grid" class="list-group-o area-maps-container" v-bind="dragOptions" @start="dragList = true" @end="changeSort">
              <div class="item" v-for="item in $store.state.areamaps.items" :key="item.id" :class="{ passive: !item.isActive }">
                <div class="table-icon">
                  <i class="burger" :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                </div>
                <div class="img-title">
                  <div class="img" :style="'background-image:url(' + $imageus + item.image + '?width=150&height=150&mode=cover)'"></div>
                  <div class="area-maps-item-title">{{ item.title }}</div>
                </div>
                <div><el-switch v-model="item.isActive" @change="toggleItem(item.id)"></el-switch></div>
                <div class="action-btns">
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button
                      type="primary"
                      icon="fas fa-pen"
                      circle
                      size="mini"
                      @click="
                        updateFormId = item.id;
                        modalVisible = true;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" :loading="loading == 'deleteItem-' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-maps-lottie'"
              :title="$t('event.menu.areamap.title')"
              @btnAdd="
                updateFormId = null;
                modalVisible = true;
              "
              @btnRefresh="refreshList()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>

          <div class="card-footer"></div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="updateFormId ? $t('contentManagement.areaMap.editMap') : $t('contentManagement.areaMap.addMap')" class="medium" center modal-append-to-body destroy-on-close>
      <AreaMapAddUpdate @deleteMe="deleteItem" v-if="modalVisible" @closeDialog="modalVisible = false" :id="updateFormId" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import AreaMapAddUpdate from "../../components/AreaMapAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.maps")
    };
  },
  components: { AreaMapAddUpdate, ExcelImport, PageCountInfo, draggable },
  name: "AreaMaps",
  data() {
    return {
      modalVisible: false,
      updateFormId: null,
      isFilterEnabled: false,
      timeout: null,
      areaMapsShort: null,
      loading: false,
      dragList: false,
      excelDialog: false,
      helpUrl: this.$helpUrl + "areamaps",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx"
    };
  },
  methods: {
    changeSort() {
      if (this.areaMapsShort != null) clearTimeout(this.areaMapsShort);
      this.loading = "loadingList";
      this.areaMapsShort = setTimeout(async () => {
        var payload = [];
        this.$store.state.areamaps.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveAreaMapsOrder", payload);
        await this.$store.dispatch("getAreaMaps");
        this.loading = false;
      }, 500);
    },
    async toggleItem(id) {
      this.loading = id;
      await this.$store.dispatch("toggleAreaMap", id);
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getAreaMaps");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    handleSizeChange(take) {
      this.$store.commit("setAreaMapTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setAreaMapPage", page);
    },
    async deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteAreaMap", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getAreaMaps");
        }
        this.loading = false;
      }, 500);
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedAreaMaps", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  async created() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getAreaMaps");
      this.loading = false;
    }, 500);
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.areamaps.filter.page - 1) * this.$store.state.areamaps.filter.take;
    },
    take() {
      return this.skip + this.$store.state.areamaps.items.length;
    }
  },
  watch: {
    "$store.state.areamaps.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getAreaMaps");
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.area-maps-grid-template {
  grid-template-columns: 36px 1fr 90px 90px;
}

.area-maps-container {
  display: flex;
  flex-direction: column;
  .item {
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    grid-template-columns: 36px 1fr 90px 90px;

    &:last-child {
      margin-bottom: unset;
    }

    & > .action-btns {
      display: flex;
      flex-direction: row;
      gap: 0.3rem;
      .el-button {
        margin: 0;
      }
    }

    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;

      & > .img {
        border-radius: 8px;
        width: 45px;
        height: 45px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        overflow: hidden;
        border: 3px solid white;
      }

      .area-maps-item-title {
        font-size: 14px;
        color: #292f3b;
        font-weight: 600;
        line-height: normal;
      }
    }

    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;

    &.passive {
      background-color: #fff2f2 !important;
    }
    display: grid;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;

      .el-input {
        width: 100%;
      }
    }

    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }

    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/AreaMaps.vue